import { motion } from "framer-motion";

const items = [
  {
    q: "How much space do you need?",
    a: "The mirror photo booth fits comfortably in about 8x8ft; add a couple of feet for the red-carpet moment and backdrop. Power outlet within 15ft.",
  },
  {
    q: "What areas do you serve?",
    a: "We're based in Chicagoland and cover the greater Chicago area, plus the surrounding suburbs. Traveling further? Give us a call and we'll quote it fairly.",
  },
  {
    q: "How fast do we get the photos?",
    a: "Prints are unlimited and delivered on-site during the event. Digital sharing is instant. Enterprise clients also receive a USB with the full digital gallery.",
  },
  {
    q: "Can we customize the templates and backdrop?",
    a: "Yes. Every package includes a backdrop of your choice and at least one custom template designed for your event. Professional and Enterprise include additional templates and a magazine keepsake.",
  },
  {
    q: "How do we book?",
    a: "Fill in the inquiry form or call George at (708) 940-3182 or Lucy at (708) 769-9419. You can also email photoboothmemories2024@gmail.com — we usually reply the same day.",
  },
];

const reveal = {
  initial: { y: 40, opacity: 0 },
  whileInView: { y: 0, opacity: 1 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] },
};

export default function FAQ() {
  return (
    <section className="relative bg-[#FDFBF7] py-24 md:py-32" data-testid="faq-section">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-10">
        <motion.div {...reveal} className="md:col-span-4">
          <div className="overline text-[#0A0A0A]/60 mb-4">FAQ</div>
          <h2 className="font-serif font-light text-4xl md:text-5xl leading-tight text-[#0A0A0A]">
            Answers, before you <em className="text-[#FF5722]">ask</em>.
          </h2>
        </motion.div>
        <div className="md:col-span-8 divide-y divide-[#0A0A0A]/10 border-t border-[#0A0A0A]/10">
          {items.map((it, i) => (
            <motion.details
              key={i}
              {...reveal}
              transition={{ ...reveal.transition, delay: i * 0.05 }}
              className="group py-6"
              data-testid={`faq-item-${i}`}
            >
              <summary className="cursor-pointer flex items-start justify-between gap-6 list-none">
                <span className="font-serif text-2xl md:text-3xl text-[#0A0A0A] leading-tight">{it.q}</span>
                <span className="mt-2 w-6 h-6 rounded-full border border-[#0A0A0A]/30 grid place-items-center group-open:rotate-45 transition-transform">
                  +
                </span>
              </summary>
              <p className="mt-4 max-w-2xl text-[#0A0A0A]/75 leading-relaxed">{it.a}</p>
            </motion.details>
          ))}
        </div>
      </div>
    </section>
  );
}
